export var GoodTableColumnFixedType;
(function (GoodTableColumnFixedType) {
    GoodTableColumnFixedType["LEFT"] = "left";
    GoodTableColumnFixedType["RIGHT"] = "right";
})(GoodTableColumnFixedType || (GoodTableColumnFixedType = {}));
export class GoodTablePaginationOptions {
    constructor() {
        this.enabled = false;
        this.mode = 'records';
        this.position = 'bottom';
        this.perPage = 20;
        this.perPageDropdownEnabled = true;
        this.perPageDropdown = [20, 50, 100, 200];
        this.dropdownAllowAll = true;
        this.setCurrentPage = 1;
        this.nextLabel = 'next';
        this.prevLabel = 'prev';
        this.rowsPerPageLabel = 'Rows per page';
        this.ofLabel = 'of';
        this.pageLabel = 'page';
        this.hideGotoEndButtons = false;
        this.lastNumber = true;
        this.infoFn = null;
    }
}
export class GoodTableSelectOptions {
    constructor() {
        this.enabled = true;
        this.selectOnCheckboxOnly = true;
        this.selectionInfoClass = 'custom-class';
        this.selectionText = 'rows selected';
        this.clearSelectionText = 'clear';
        this.disableSelectInfo = true;
        this.selectAllByGroup = true;
    }
}
export class GoodTableSortOptions {
    constructor() {
        this.enabled = true;
        this.multipleColumns = true;
    }
}
export class GoodTableOptions {
    constructor() {
        this.columns = [];
        this.rows = [];
        this.fixedHeader = false;
        this.lineNumbers = false;
        this.rtl = false;
        this.rowStyleClass = 'clickable';
        this.compactMode = false;
        this.isLoading = false;
        this.styleClass = 'vgt-table bordered';
    }
}
